"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawBalanceResult = exports.WithdrawBalanceDto = void 0;
class WithdrawBalanceDto {
    amount;
    currency;
    /** Optional caller-provided key that makes repeated requests safe. */
    idempotencyKey;
    /** Explicitly authorize withdrawing up to amount when less is available. Requires idempotencyKey. */
    allowPartial;
    /** Return the current transaction status also for exact withdrawals. Legacy callers keep an empty response. */
    returnDetails;
}
exports.WithdrawBalanceDto = WithdrawBalanceDto;
/** Returned for partial mode or explicitly requested details; legacy exact requests keep their response. */
class WithdrawBalanceResult {
    transactionId;
    requestedAmount;
    amount;
    currency;
    partial;
    status;
}
exports.WithdrawBalanceResult = WithdrawBalanceResult;
